import CONSTANT from "@api/constant";
export default [{
  path: '/market',
  name: 'market',
  meta: {
    platformType: CONSTANT.SUPPLIER
  },
  component: function component() {
    return import('@/layouts/market-layout/admin.vue');
  },
  redirect: {
    name: 'm-supplierMemberCenter'
  },
  children: [{
    path: 'supplierMemberCenter',
    name: 'm-supplierMemberCenter',
    component: function component() {
      return import('@/pagesMarket/supplier/memberCenter/memberCenter/index.vue');
    }
  }]
}];